import {get, post} from "@/config/api";


const state = {
  goodMap: {},
};

const getters = {
};

const mutations = {};

const actions = {
  GetGoodsById({}, params) {
    return new Promise((resolve, reject) => {
      let goodMap = state.goodMap;
      let good = goodMap[params.id];
      if (good && good.id) {
        resolve(good)
      } else {
        get(`goods/get/${params.id}/`, params).then((data) => {
          let good_data = data.data
          if (good_data && good_data.id) {
            state.goodMap[good_data.id] = good_data
          }
          resolve(data.data);
        }, (error) => {
          reject(error)
        })
      }
    });
  },

  CalcOrderGoodPrice({}, params) {
    return new Promise((resolve, reject) => {
      post("v2/goods/price/calc/", params).then((data) => {
        resolve(data)
      }, (err) => {
        reject(err)
      })
    })
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
